import React, { useState } from 'react'
import {
	Box,
	Card,
	CardContent,
	Skeleton,
	Typography,
	Stack,
	Pagination,
	CardActionArea,
} from '@mui/material'
import { useGetQuestionsQuery } from '../store/api/vacanciesApi'
import { Clarification } from '../types'
import { useNavigate } from 'react-router-dom'

const statusMapping: { [key: string]: string } = {
	PENDING: 'Очікує відповіді',
	ACTIVE: 'Відповідь заповнюється',
	FINISHED: 'Відповідь отримана',
	DECLINED: 'Відхилено',
}

const Questions = () => {
	const [page, setPage] = useState(1)
	const { data, isLoading } = useGetQuestionsQuery({ page, page_size: 10 })

	const navigate = useNavigate()

	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
			<Typography variant="h4" gutterBottom>
				Уточнення
			</Typography>
			{isLoading || !data ? (
				<Stack sx={{width: '100%', alignItems: 'center'}} spacing={2}>
					<Skeleton variant="rectangular" height={161} width={700} />
					<Skeleton variant="rectangular" height={161} width={700} />
					<Skeleton variant="rectangular" height={161} width={700} />
					<Skeleton variant="rectangular" height={161} width={700} />
				</Stack>
			) : (
				<Box>
					<Stack sx={{width: '100%', alignItems: 'center'}} spacing={2}>
						{data.results.map((clarification) => (
							<Card sx={{maxWidth: '700px', width: '100%'}} key={clarification.id}>
								<CardActionArea onClick={() => navigate(`/questions/${clarification.id}`)}>
									<CardContent>
										<Typography variant="h6">
											{clarification.candidate_name} -{' '}
											{clarification.vacancy_title}
										</Typography>
										<Typography color='textSecondary'>
											{new Date(clarification.created_at).toLocaleString()}
										</Typography>
										<Typography sx={{mb: 1}}>
											{statusMapping[clarification.status] || clarification.status}
										</Typography>
										<Box
											sx={{
												border: '1px solid',
												borderColor: 'gray.500',
												borderRadius: 2,
												p: 1,
											}}
										>
											<Typography>Запит: {clarification.extra_notes}</Typography>
										</Box>
									</CardContent>
								</CardActionArea>
							</Card>
						))}
					</Stack>
					{data && data.count > 10 && (
						<Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
							<Pagination
								count={Math.ceil(data.count / 10)}
								page={page}
								onChange={(event: React.ChangeEvent<unknown>, value: number) =>
									setPage(value)
								}
								color="primary"
							/>
						</Box>
					)}
				</Box>
			)}
		</Box>
	)
}

export default Questions
